<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Аудио обучения</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="/teaching-audios/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Добавить адуио
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Список аудио обучения</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="audioList" :fields="tableFields">
                <template #cell(name)="row">
                  <div v-html="row.item.name"></div>
                </template>
                <template #cell(audio)="row">
                  <audio controls class="focus-outline-none" preload="none">
                    <source :src="row.item.audio" type="audio/ogg">
                  </audio>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/teaching-audios/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="removeTeachingAudio(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restTeachingAudio(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="removeTeachingAudio(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'TeachingAudio',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {},
      audioList: []
    }
  },
  computed: {
    ...mapState({
      teachingAudiosList: state => state.teachingAudio.teachingAudiosList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'name.' + this.$i18n.locale,
          label: 'Название',
          sortable: true
        },
        {
          key: 'description.' + this.$i18n.locale,
          label: 'Описание',
          sortable: true
        },
        {
          key: 'audio',
          label: 'Аудио',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getAudios({})
  },
  destroyed () {
    this.audioList = []
  },
  methods: {
    ...mapActions({
      getAllTeachingAudios: 'teachingAudio/getAllTeachingAudios',
      deleteTeachingAudio: 'teachingAudio/deleteTeachingAudio',
      restoreTeachingAudio: 'teachingAudio/restoreTeachingAudio'
    }),
    getAudios (params) {
      this.getAllTeachingAudios(params).then(res => {
        this.audioList = this.teachingAudiosList
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    changePaginationPerPage (value) {
      this.getVideos({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getVideos({ page: page, count: this.paginationPerPage })
    },
    removeTeachingAudio (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteTeachingAudio({ id }).then(res => {
            this.audioList = this.teachingAudiosList
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restTeachingAudio (id) {
      this.restoreTeachingAudio({ id }).then(res => {
      })
    }
  }
}
</script>
